import { IDevice } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../../../widgets/entry-components/alert/services/alert.service';
import { AbstractDetailsComponent } from '../../../shared/abstracts/details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['./device-details.component.scss'],
})
export class DeviceDetailsComponent extends AbstractDetailsComponent<IDevice> {
  @Input() hideDeleteButton = false;
  @Output() callDelete = new EventEmitter<string>();

  constructor(private router: Router, private alertService: AlertService) {
    super();
  }

  navToUpdate() {
    this.router.navigateByUrl('/device-add', { state: { parameter: this.inData } });
  }

  deleteDeviceAlert(id: string, identifier: string) {
    this.alertService.presentDelete(identifier, 'DEVICE', () => { this.callDelete.emit(id); });
  }

}
